import React from 'react';
import clsx from 'clsx';
import styles from './ChoiceRow.module.scss';

const ChoiceRow = ({
  align = 'center', // 'center' | 'top'
  className,
  children,
}) => {
  return (
    <div
      className={clsx(
        styles.root,
        styles[align],
        className
      )}
    >
      {children}
    </div>
  );
};

export default ChoiceRow;
